import { get, post, put, deleteApi } from './request'
/**
 * 验证码登陆（渠道账户一体化专用接口）
 * @param {*} data
 * @returns
 */
function integrationCodeLogin(data) {
  return post('/external-channel/open/integration/auth/compatibleLogin/codeLogin', data, '/channel-api')
}
/**
 * 密码登陆（渠道账户一体化专用接口）
 * @param {*} data
 * @returns
 */
function integrationPwdLogin(data) {
  return post('/external-channel/open/integration/auth/compatibleLogin/pwd', data, '/channel-api')
}
/**
 * 获取验证码（渠道账户一体化专用接口）
 * @param {*} data
 * @returns
 */
function integrationSendSmsByUserId(data) {
  return post('/external-channel/open/integration/auth/compatibleLogin/sendSmsByUserId', data, '/channel-api')
}
/**
 * 退出登录（渠道账户一体化专用接口）
 * @param {*} data
 * @returns
 */
function integrationLogout(data) {
  return post('/external-channel/basic/integration/auth/logout', data, '/channel-api')
}
/**
 * 用户修改状态、禁用、启用
 * @param {*} data
 * @returns
 */
function modifyState(data) {
  return post('/external-channel/basic/integration/integrationChannelManage/modifyState', data, '/channel-api')
}
/**
 * 推广员工修改状态、禁用、启用
 * @param {*} data
 * @returns
 */
function modifyPromoteEmployeesState(data) {
  return post('/external-channel/basic/integration/integrationChannelManage/modifyPromoteEmployeesState', data, '/channel-api')
}

export { integrationCodeLogin, integrationPwdLogin, integrationSendSmsByUserId, integrationLogout, modifyState, modifyPromoteEmployeesState }
